export default "/images/vendor/flag-icon-css/flags/1x1/ge.svg?7ccc29e2355cf25d55c56b48a81588b1";